module.exports = new __parcel__URL__("WorkListError_ptc.b9457501.svg").toString();